import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { AssetService, AuthenticationService } from "@app/_services";
import { Asset, AssetTypeName } from "@app/_models/_DTOs/asset";
import { ITuple } from "@app/_models/tuple";
import { BreakpointObserver } from "@angular/cdk/layout";
import { UploadFile } from "ng-zorro-antd";
import {
  AssetHistory,
  AssetHistoryActionName,
} from "@app/_models/_DTOs/assetHistory";
import { AssetHistoryActionType } from "@app/_models/assetHistoryActionType";
import { AssetViewModel } from "@app/_models/_viewModels/asset.viewmodel";
import { LocationService } from "@app/_services/location.service";
import { DepartmentService } from "@app/_services/department.service";
import { SupplierService } from "@app/_services/supplier.service";
import { EmployeeService } from "@app/_services/employee.service";
import { AssetGroup } from "@app/_models/_DTOs/assetGroup";
import { AssetGroupService } from "@app/_services/assetGroup.service";
import { Department } from "@app/_models/_DTOs/department";
import { Supplier } from "@app/_models/_DTOs/supplier";
import { Employee } from "@app/_models/_DTOs/employee";
import { AssetType } from "@app/_models/enums/assetType";

import { NzMessageService } from "ng-zorro-antd";
import { NgForm } from "@angular/forms";
import { environment } from "@environments/environment";
import { DocumentService } from "@app/_services/document.service";
import { Location } from "@app/_models/_DTOs/location";
import { AssetDetailsComponent } from "@app/assets/asset-details/asset-details.component";
import { ResizeService } from "@app/_services/resize.service";
import { SCREEN_SIZE } from "@app/_helpers/screen-size.enum";
import { AssetEditorComponent } from "@app/assets/asset-editor/asset-editor.component";
import { Sort } from "@app/_models/sort";
import { SortDirection } from "@app/_models/enums/sortDirection";
import { AssetDiscardProposal } from "@app/_models/_DTOs/assetDiscardProposal";
import { DiscardActionViewModel } from "@app/_models/_viewModels/discardAction.viewmodel";
import { NumberHelper } from "@app/_helpers/number.helper";
import { AssetHelper } from "@app/_helpers/asset.helper";
import { BaseComponent } from "@app/_shared/base.component";
import { UserToken } from "@app/_models";
import { LegalEntity } from "@app/_models/_DTOs/legalEntity";
import { LegalEntityService } from "@app/_services/legalEntity.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-assets",
  templateUrl: "./assets.component.html",
  styleUrls: ["./assets.component.css"],
})
export class AssetsComponent extends BaseComponent implements OnInit {
  onScreenResize(screenSize: SCREEN_SIZE) { }
  onUserAvailable(userToken: UserToken) { }
  level: number = 0;
  legalEntity: LegalEntity = null;

  sorts: Sort[] = [];
  pageIndex = 1;
  pageSize = 10;
  total = 1;
  assetList: Asset[] = [];
  loading = true;
  loadingDropdowns = false;
  editDrawerVisible: boolean = false;
  isSavingAsset: boolean = false;
  isDiscardingAsset: boolean = false;
  uploadPercentage: number = 0;
  isEditing: boolean = false;
  isDiscardModalOpen: boolean = false;

  locations: Location[] = [];
  // filteredLocations: Location[] = [];
  assetGroups: AssetGroup[] = [];
  departments: Department[] = [];
  suppliers: Supplier[] = [];
  employees: Employee[] = [];
  legalEntities: LegalEntity[] = [];

  @ViewChild(AssetDetailsComponent, { static: false })
  private assetDetailsComponent: AssetDetailsComponent;

  @ViewChild(AssetEditorComponent, { static: false })
  private assetEditorComponent: AssetEditorComponent;

  assetViewModel: AssetViewModel = null;
  assetDiscardViewModel: DiscardActionViewModel = null;
  assetDiscardProposal: AssetDiscardProposal = null;

  selectedEmployee: Employee;

  selectedLocation: Location;

  nameSearchValue = "";
  inventoryCodeSearchValue = "";
  barcodeSearchValue = "";
  departmentIdSearchValue: number[] = [];
  employeeIdSearchValue: number[] = [];
  locationIdSearchValue: number[] = [];
  assetTypeSearchValue: number[] = [];
  assetGroupSearchValue: number[] = [];
  supplierIdSearchValue: number[] = [];
  legalEntityIdSearchValue: number[] = [];

  public assetHistoryActionType = AssetHistoryActionType;
  public assetTypes = AssetType;

  errorMessages = {};

  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true,
  };
  fileList: UploadFile[] = [];
  previewImage: string | undefined = "";
  previewVisible = false;

  allowedFormats = [
    "EAN_13",
    "CODE_128",
    "CODABAR",
    "CODE_39",
    "CODE_93",
    "EAN_8",
    "UPC_A",
    "UPC_E",
  ];
  scannerError: string = "";
  barCodeScannerEnabled: boolean = false;

  apiUrl: string;

  screenSize: SCREEN_SIZE;

  public filterTimerStarted = false;
  public filterTimer;

  constructor(
    private assetService: AssetService,
    private breakpointObserver: BreakpointObserver,
    private locationService: LocationService,
    private departmentService: DepartmentService,
    private supplierService: SupplierService,
    private employeeService: EmployeeService,
    private assetGroupService: AssetGroupService,
    private messageService: NzMessageService,
    private documentService: DocumentService,
    private legalEntityService: LegalEntityService,
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(authenticationService, resizeService);
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe((size) => {
      this.screenSize = size;
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let legalEntityId = +params["legalEntityId"];
      if (legalEntityId != null && !Number.isNaN(legalEntityId)) {
        this.legalEntityService.get(legalEntityId).subscribe(
          (legalEntity: LegalEntity) => {
            if (legalEntity) {
              this.legalEntity = legalEntity;
              this.legalEntityIdSearchValue = [legalEntity.id];
              this.searchData();
            } else {
              this.router.navigate(["/not-found"]);
            }
          },
          (error) => {
            this.router.navigate(["/not-found"]);
          }
        );
      }
    });
    this.loadDataForDropdowns();
    this.searchData(true);
    if (this.resizeService.currentSize != null) {
      this.screenSize = this.resizeService.currentSize;
    }
  }

  loadDataForDropdowns() {
    this.departmentService.getAllBasic().subscribe((data: Department[]) => {
      this.departments = data;
    });
    this.employeeService.getAllBasic().subscribe((data: Employee[]) => {
      this.employees = data;
    });
    this.locationService.getAllBasic().subscribe((data: Location[]) => {
      this.locations = data;
    });
    this.assetGroupService.getAllBasic().subscribe((data: AssetGroup[]) => {
      this.assetGroups = data;
    });
    this.supplierService.getAllBasic().subscribe((data: Supplier[]) => {
      this.suppliers = data;
    });
    this.legalEntityService.getAllBasic().subscribe((data: LegalEntity[]) => {
      this.legalEntities = data;
    });
  }

  sort(sort: { key: string; value: string }): void {
    var newSort: Sort = {
      PropertyName: sort.key,
      Direction: null,
    };
    if (sort.value) {
      if (sort.value == "ascend") {
        newSort.Direction = SortDirection.Ascending;
      } else {
        newSort.Direction = SortDirection.Descending;
      }
    }

    if (newSort.Direction == null) {
      var existingSort = this.sorts.find(
        (x) => x.PropertyName == newSort.PropertyName
      );
      if (existingSort) {
        const index = this.sorts.indexOf(existingSort);
        if (index > -1) {
          this.sorts.splice(index, 1);
        }
      }
    } else {
      var existingSort = this.sorts.find(
        (x) => x.PropertyName == newSort.PropertyName
      );
      if (existingSort) {
        existingSort.Direction = newSort.Direction;
      } else {
        this.sorts.push(newSort);
      }
    }
    this.searchData();
  }

  getSortString() {
    var sortString = "";
    if (this.sorts && this.sorts.length > 0) {
      for (let sort of this.sorts) {
        if (sort.Direction == SortDirection.Ascending) {
          if (sortString.length == 0) {
            sortString = sort.PropertyName;
          } else {
            sortString += "," + sort.PropertyName;
          }
        } else {
          if (sortString.length == 0) {
            sortString = "-" + sort.PropertyName;
          } else {
            sortString += ",-" + sort.PropertyName;
          }
        }
      }
    }
    return sortString;
  }

  getFilters(){
    var filters = "";
    if (this.nameSearchValue.length > 0) {
      filters += "Name@=" + this.nameSearchValue + ",";
    }
    if (this.inventoryCodeSearchValue.length > 0) {
      filters += "AssetInventoryNumber@=" + this.inventoryCodeSearchValue + ",";
    }
    if (this.barcodeSearchValue.length > 0) {
      filters += "BarCode@=" + this.barcodeSearchValue + ",";
    }
    if (this.departmentIdSearchValue.length > 0) {
      filters +=
        "DepartmentId==" + this.departmentIdSearchValue.join("|") + ",";
    }
    if (this.employeeIdSearchValue.length > 0) {
      filters +=
        "(EmployeeId|Location.PersonInChargeId)==" +
        this.employeeIdSearchValue.join("|") +
        ",";
    }
    if (this.locationIdSearchValue.length > 0) {
      filters += "LocationId==" + this.locationIdSearchValue.join("|") + ",";
    }
    if (this.assetTypeSearchValue.length > 0) {
      filters += "Type==" + this.assetTypeSearchValue.join("|") + ",";
    }
    if (this.assetGroupSearchValue.length > 0) {
      filters += "GroupId==" + this.assetGroupSearchValue.join("|") + ",";
    }
    if (this.supplierIdSearchValue.length > 0) {
      filters += "SupplierId==" + this.supplierIdSearchValue.join("|") + ",";
    }
    if (this.legalEntityIdSearchValue.length > 0) {
      filters +=
        "Department.LegalEntityId==" +
        this.legalEntityIdSearchValue.join("|") +
        ",";
    }
    return filters;
  }

  getSort(){
    var sortString = this.getSortString();
    if (sortString.length == 0) {
      sortString = "-Created";
    } else {
      sortString += ",-Created";
    }
    return sortString;
  }

  searchData(reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }
    var filters = this.getFilters();
    var sortString = this.getSort();

    this.loading = true;
    this.assetService
      .getPage(this.pageIndex, this.pageSize, sortString, filters)
      .subscribe((data: ITuple<Asset>) => {
        this.loading = false;
        this.total = data.item2;
        this.assetList = data.item1;
      });
  }

  exportExcel(){
    var filters = this.getFilters();
    var sortString = this.getSort();
    this.assetService
    .exportExcel(this.pageIndex, this.pageSize, sortString, filters)
    .subscribe(
      (result) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result);
        }
        else {
          var fileUrl = URL.createObjectURL(result);

          var anchor = document.createElement("a");
          anchor.download = "Popis imovine.xlsx";
          anchor.href = fileUrl;
          anchor.click();
        }
      });
  }

  initModel(asset?: Asset) {
    this.fileList = [];
    if (asset) {
      this.isEditing = true;
      this.assetViewModel = {
        id: asset.id ? asset.id : -1,
        type: asset.type ? asset.type : undefined,
        inventoryCode: asset.inventoryCode
          ? NumberHelper.pad(
            parseInt(AssetHelper.ParseInventoryCodeNumber(asset)),
            4
          )
          : "",
        inventoryCodeNumber: asset.inventoryCodeNumber
          ? asset.inventoryCodeNumber
          : 0,
        barCode: asset.barCode ? asset.barCode : "",
        name: asset.name ? asset.name : "",
        description: asset.description ? asset.description : "",
        serialNumber: asset.serialNumber ? asset.serialNumber : "",
        qty: asset.qty ? asset.qty : 1,
        purchasePrice: asset.purchasePrice ? asset.purchasePrice : 0,
        currentValue: asset.currentValue ? asset.currentValue : undefined,
        purchaseDate: asset.purchaseDate ? asset.purchaseDate : new Date(),
        notes: asset.notes ? asset.notes : "",
        condition: asset.condition ? asset.condition : undefined,
        retiredDate: asset.retiredDate ? asset.retiredDate : undefined,
        warrantyExpirationDate: asset.warrantyExpirationDate
          ? asset.warrantyExpirationDate
          : undefined,
        manufacturer: asset.manufacturer ? asset.manufacturer : "",
        media: asset.media ? asset.media : undefined,
        departmentId: asset.department ? asset.department.id : undefined,
        employeeId: asset.employee ? asset.employee.id : undefined,
        assetGroupId: asset.assetGroup ? asset.assetGroup.id : undefined,
        locationId: asset.location ? asset.location.id : undefined,
        supplierId: asset.supplier ? asset.supplier.id : undefined,
      };
    } else {
      this.isEditing = false;
      this.assetViewModel = {
        id: -1,
        type: undefined,
        inventoryCode: "",
        inventoryCodeNumber: 0,
        barCode: "",
        name: "",
        description: "",
        serialNumber: "",
        qty: 1,
        purchasePrice: 0,
        currentValue: undefined,
        purchaseDate: new Date(),
        notes: "",
        condition: undefined,
        retiredDate: undefined,
        warrantyExpirationDate: undefined,
        manufacturer: "",
        media: undefined,
        departmentId: undefined,
        employeeId: undefined,
        assetGroupId: undefined,
        locationId: undefined,
        supplierId: undefined,
      };
    }
  }

  reset(): void {
    this.nameSearchValue = "";
    this.inventoryCodeSearchValue = "";
    this.barcodeSearchValue = "";
    this.departmentIdSearchValue = [];
    this.employeeIdSearchValue = [];
    this.locationIdSearchValue = [];
    this.assetTypeSearchValue = [];
    this.assetGroupSearchValue = [];
    this.supplierIdSearchValue = [];
    if (this.legalEntity == null) {
      this.legalEntityIdSearchValue = [];
    }
    this.searchData(true);
  }

  editAsset(asset: Asset) {
    this.initModel(asset);
  }

  deleteAsset(id: number) {
    this.assetService.delete(id).subscribe(
      (result) => {
        this.messageService.create("success", "Imovina uspješno obrisana");
        this.searchData();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // onLocationInput(value: string): void {
  //   this.filteredLocations = this.locations.filter(location => location.name.toLowerCase().includes(value.toLowerCase()));
  // }

  openCreateAssetForm() {
    this.isEditing = false;
    this.initModel();
  }

  closeEditDrawer(reload: boolean) {
    this.assetViewModel = null;
    this.isEditing = false;
    if (reload) {
      this.searchData();
    }
  }

  openDetails(asset: Asset) {
    this.assetDetailsComponent.loadAsset(asset.id);
  }

  closeDetails() {
    this.assetDetailsComponent.selectedAsset = null;
    this.assetDetailsComponent.isOpen = false;
  }

  openEmployeeDetails(employee: Employee) {
    this.employeeService.get(employee.id).subscribe((data: Employee) => {
      this.selectedEmployee = data;
    });
  }

  openLocationDetails(location: Location) {
    this.locationService.get(location.id).subscribe((data: Location) => {
      this.selectedLocation = data;
    });
  }

  closeEmployeeDetails() {
    this.selectedEmployee = null;
    this.searchData();
  }

  closeLocationDetails() {
    this.selectedLocation = null;
    this.searchData();
  }

  generateDocument(asset: Asset) {
    var assetHistoryIds = [];
    var assets: Asset[] = [];
    assets.push(asset);
    this.documentService.generateDocument(assets).subscribe(
      (result) => {
        this.messageService.create("success", "Dokument uspješno generiran");
        this.searchData();
      },
      (error) => { }
    );
  }

  getPdf(assetHistoryAction: AssetHistory) {
    var document = assetHistoryAction.documents.sort((val1, val2) => {
      return (
        new Date(val2.created).getTime() - new Date(val1.created).getTime()
      );
    })[0];
    this.documentService.getPdf(document.id).subscribe((result: any) => {
      if (result.type == "application/pdf") {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, "_blank");
        }
      } else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    });
  }

  openDiscardModal(assetId: number) {
    this.assetService
      .getAssetDiscardProposal(assetId)
      .subscribe((assetDiscardProposal: AssetDiscardProposal) => {
        this.assetDiscardViewModel = {
          id: -1,
          assetId: assetId,
          remark: "",
          inventoryAssetActionId: null,
        };
        if (assetDiscardProposal) {
          this.assetDiscardProposal = assetDiscardProposal;
          if (
            assetDiscardProposal.inventoryAssetAction &&
            assetDiscardProposal.inventoryAssetAction.id != undefined
          ) {
            this.assetDiscardViewModel.inventoryAssetActionId =
              assetDiscardProposal.inventoryAssetAction.id;
          }
        }

        this.isDiscardModalOpen = true;
      });
  }

  closeDiscardModal() {
    this.assetDiscardViewModel = null;
    this.isDiscardModalOpen = false;
    this.assetDiscardProposal = null;
  }

  discardAsset(form: NgForm) {
    this.isDiscardingAsset = true;
    this.assetService.discardAsset(this.assetDiscardViewModel).subscribe(
      (result) => {
        this.messageService.create("success", "Rashod uspješno proveden");
        this.isDiscardingAsset = false;
        this.searchData(true);
        this.closeDiscardModal();
        if (result.type == "application/pdf") {
          var blob = new Blob([result], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var fileUrl = URL.createObjectURL(blob);
            window.open(fileUrl, "_blank");
          }
        } else {
          this.messageService.create("error", "Dokument nije pronađen.");
        }
      },
      (error) => {
        if (error.ParamName) {
          if (form.controls[error.ParamName]) {
            form.controls[error.ParamName].setErrors({ custom: true });
            var errorMessage = error.Message.split("Parameter name")[0];
            this.errorMessages[error.ParamName] = errorMessage;
          }
        }
        this.isDiscardingAsset = false;
      }
    );
  }

  enableScanner() {
    this.scannerError = "";
    this.barCodeScannerEnabled = true;
  }

  disableScanner() {
    this.scannerError = "";
    this.barCodeScannerEnabled = false;
  }

  barCodeScanSuccessHandler(scanResult: string) {
    if (scanResult && scanResult.length > 0) {
      this.barcodeSearchValue = scanResult;
      this.disableScanner();
      this.searchData();
    } else {
      this.barcodeSearchValue = "";
    }
  }

  public getActionTypeName(actionType: AssetHistoryActionType) {
    return AssetHistoryActionName.get(actionType).name;
  }

  public getAssetTypeName(assetType: AssetType) {
    return AssetTypeName.get(assetType);
  }

  public assetTypeKeys() {
    var keys = Object.keys(this.assetTypes);
    return keys.slice(keys.length / 2);
  }
}
